<template>
  <!-- 课程介绍 -->
  <div class="course-intro-container">
    <!-- 统计卡片 -->
    <div :class="['stats-section', { fixed: isTabFixed }]">
      <div class="stats-card">
        <div class="stat-left">
          <div class="stat-large stat-card-01">
            <div class="large-info">
              <div class="large-label">本期学分</div>
              <div class="large-value credit-value">{{ content.credit || 0 }}</div>
            </div>
          </div>
          <div class="stat-large stat-card-02">
            <div class="large-info">
              <div class="large-label">本期学时</div>
              <div class="large-value class-hours-value">{{ content.class_hours || 0 }}</div>
            </div>
          </div>
        </div>
        <div class="stat-right">
          <div class="stat-small stat-card-03">
            <div class="small-info">
              <div class="small-label">本期加入人数</div>
              <div class="small-value join-count-value">{{ content.join_count || 0 }}</div>
            </div>
          </div>
          <div class="stat-small stat-card-04">
            <div class="small-info">
              <div class="small-label">累计加入人数</div>
              <div class="small-value cumulative-join-count-value">{{ courseInfo.join_count || courseInfo.join_count ||
                0 }}
              </div>
            </div>
          </div>
          <div class="stat-small stat-card-05">
            <div class="small-info">
              <div class="small-label">本期点击量</div>
              <div class="small-value view-count-value">{{ content.view_count || 0 }}</div>
            </div>
          </div>
          <div class="stat-small stat-card-06">
            <div class="small-info">
              <div class="small-label">累计点击量</div>
              <div class="small-value cumulative-view-count-value">{{ courseInfo.view_count || courseInfo.view_count ||
                0 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 课程介绍 -->
    <div class="course-intro-content">
      <div class="course-intro">
        <div class="intro-title">
          <el-image :src="courseImg" class="title-icon" />
          <div class="title-text"><span>课程介绍</span></div>

        </div>
        <div class="intro-content" v-html="formatContent(content.brief)"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "courseintro",
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
    courseInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      courseImg: require("@/assets/course/UIout/courseintro/courseintro_decor_01.png"),
      isTabFixed: false,
    }

  },
  created() {
    console.log(this.courseInfo, 'courseInfo');

  },
  mounted() {
    this.initTabBarSticky()
  },
  methods: {
    initTabBarSticky() {
      this.$nextTick(() => {
        const tabsBar = this.$refs.tabsBarRef
        if (!tabsBar) return
        this.tabBarHeight = tabsBar.offsetHeight
        // 记录导航栏在文档中的原始垂直位置（相对文档顶部，不受 fixed 影响）
        this.tabBarOffsetTop = tabsBar.getBoundingClientRect().top + window.pageYOffset
        this.handleTabScroll = () => {
          // 用滚动距离与原始位置比较，向上滑过即悬浮，向下滑回即还原
          this.isTabFixed = window.pageYOffset >= this.tabBarOffsetTop
        }
        window.addEventListener("scroll", this.handleTabScroll, { passive: true })
      })
    },
    initdata(obj) {
      // 预留初始化方法，兼容父组件调用
      console.log("课程介绍 initdata", obj)
    },
    formatContent(text) {
      if (!text) return "暂无课程介绍"
      return text.replace(/\n/g, "<br/>")
    },
  },
}
</script>

<style lang="scss" scoped>
.course-intro-container {

  /* 统计卡片 */
  .stats-section {
    max-width: 1750px;
    margin: -2vw auto 0;
    // padding: clamp(20px, 2.5vw, 40px) clamp(20px, 2.5vw, 40px) 0px;
    position: relative;
    z-index: 2;
    padding: clamp(16px, 1.5vw, 24px);
    background: #ffffff;
    box-shadow: 0px 2px 8px 0px rgba(128, 112, 250, 0.1);
    border-radius: 12px 12px 12px 12px;
    margin-bottom: 20px;


    &.fixed {
      margin-top: clamp(80px, 8vw, 120px);
    }

    .stats-card {
      display: flex;
      gap: 16px;
      // background: #ffffff;
      border-radius: 20px;
      padding-top: 50px;
      // padding: 20px;
      // box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);

      .stat-left {
        flex: 0 0 45%;
        display: flex;
        gap: 16px;
        min-width: 0;

        .stat-large {
          position: relative;
          flex: 1;
          min-width: 0;
          border-radius: 16px;
          padding: 22px;
          background-repeat: no-repeat;
          background-size: cover;
          // background-position: center;
          display: flex;
          align-items: center;
          transition: transform 0.3s;
          aspect-ratio: 300 / 300;

          &:hover {
            transform: translateY(-3px);
          }

          .large-info {
            width: 100%;
            margin-top: 45%;

            .large-label {
              font-size: clamp(12px, 1vw, 15px);
              color: #333333;
              // margin-bottom: 50px;
              font-weight: bold;
              font-size: 20px;
              color: #333333;
              // text-align: center;
              font-style: normal;
              text-transform: none;
            }

            .large-value {
              // font-size: clamp(22px, 2.3vw, 34px);
              // font-weight: 700;
              // color: #333333;
              margin-top: 20%;

              &.credit-value {
                font-weight: bold;
                font-size: 36px;
                color: #8070FA;
                text-align: center;
                font-style: normal;
                text-transform: none;
              }

              &.class-hours-value {
                font-weight: bold;
                font-size: 36px;
                color: #1990FF;
                text-align: center;
                font-style: normal;
                text-transform: none;
              }
            }
          }
        }

        .stat-card-01 {
          background-image: url(~@/assets/course/UIout/courseintro/courseintro_card_01.png);
        }

        .stat-card-02 {
          background-image: url(~@/assets/course/UIout/courseintro/courseintro_card_02.png);
        }
      }

      .stat-right {
        flex: 1;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
        min-width: 0;

        .stat-small {
          display: flex;
          align-items: center;
          min-height: 130px;
          padding: 0 20px;
          border-radius: 16px;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
          transition: transform 0.3s;

          &:hover {
            transform: translateY(-3px);
          }

          .small-info {
            margin-left: 50%;
            text-align: right;

            .small-label {
              font-weight: 500;
              font-size: 18px;
              color: #333333;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }

            .small-value {
              font-size: clamp(18px, 1.8vw, 26px);
              font-weight: 700;
              color: #333333;
              margin-top: 15px;

              &.join-count-value {
                font-weight: bold;
                font-size: 36px;
                color: #52E0B9;
                text-align: center;
                font-style: normal;
                text-transform: none;
              }

              &.cumulative-join-count-value {
                font-weight: bold;
                font-size: 36px;
                color: #FE86BE;
                text-align: center;
                font-style: normal;
                text-transform: none;
              }

              &.view-count-value {
                font-weight: bold;
                font-size: 36px;
                color: #FEB313;
                text-align: center;
                font-style: normal;
                text-transform: none;
              }

              &.cumulative-view-count-value {
                font-weight: bold;
                font-size: 36px;
                color: #9747FF;
                text-align: center;
                font-style: normal;
                text-transform: none;
              }
            }
          }
        }

        .stat-card-03 {
          background-image: url(~@/assets/course/UIout/courseintro/courseintro_card_03.png);
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;

          .small-value {
            color: #10b981;
          }
        }

        .stat-card-04 {
          background-image: url(~@/assets/course/UIout/courseintro/courseintro_card_05.png);
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;

          .small-value {
            color: #ec4899;
          }
        }

        .stat-card-05 {
          background-image: url(~@/assets/course/UIout/courseintro/courseintro_card_04.png);

          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;

          .small-value {
            color: #f59e0b;
          }
        }

        .stat-card-06 {
          background-image: url(~@/assets/course/UIout/courseintro/courseintro_card_06.png);
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;

          .small-value {
            color: #a855f7;
          }
        }
      }
    }
  }

  .course-intro-content {
    background: #ffffff;
    box-shadow: 0px 2px 8px 0px rgba(128, 112, 250, 0.1);
    border-radius: 12px 12px 12px 12px;

    .course-intro {
      padding: 10px;
      min-height: 400px;
      background: url(~@/assets/course/UIout/courseintro/courseintro_decor_02.png) no-repeat;
      background-position: right bottom; // 装饰图片位置

      .intro-title {
        padding-top: 20px;
        height: 50px;
        overflow: hidden;

        .title-icon {
          position: absolute;
        }

        .title-text {
          font-weight: 500;
          font-size: 18px;
          color: #333333;
          text-align: left;
          font-style: normal;
          text-transform: none;
          position: relative;
          left: 5%;
        }

        i {
          margin-right: 8px;
          color: #7b5cff;
          font-size: 20px;
        }
      }

      .intro-content {
        font-weight: 400;
        font-size: 16px;
        color: #000000;
        line-height: 32px;
        text-align: justified;
        font-style: normal;
        text-transform: none;
        text-indent: 2em;
        padding: 25px;

      }


    }
  }

}

/* 响应式 */
@media screen and (max-width: 1200px) {
  .course-intro-container {
    .stats-section {
      .stats-card {
        .stat-left {
          flex: 0 0 100%;
          flex-direction: row;
        }

        .stat-right {
          flex: 1;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .course-intro-container {
    .stats-section {
      padding: 12px;

      &.fixed {
        margin-top: 70px;
      }

      .stats-card {
        padding-top: 30px;
        gap: 12px;

        .stat-left {
          flex-direction: column;

          .stat-large {
            padding: 16px;

            .large-info {
              .large-label {
                font-size: 16px;
                margin-bottom: 30px;
              }

              .large-value {

                &.credit-value,
                &.class-hours-value {
                  font-size: 28px;
                }
              }
            }
          }
        }

        .stat-right {
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;

          .stat-small {
            min-height: 100px;
            padding: 0 12px;

            .small-info {
              margin-left: 40%;

              .small-label {
                font-size: 14px;
              }

              .small-value {

                &.join-count-value,
                &.cumulative-join-count-value,
                &.view-count-value,
                &.cumulative-view-count-value {
                  font-size: 26px;
                }
              }
            }
          }
        }
      }
    }

    .course-intro-content {
      .course-intro {
        .intro-title {
          .title-text {
            font-size: 16px;
          }
        }

        .intro-content {
          font-size: 14px;
          line-height: 28px;
          padding: 16px;
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .course-intro-container {
    .stats-section {
      .stats-card {
        .stat-left {
          .stat-large {
            .large-info {
              .large-label {
                font-size: 14px;
                margin-bottom: 20px;
              }

              .large-value {

                &.credit-value,
                &.class-hours-value {
                  font-size: 24px;
                }
              }
            }
          }
        }

        .stat-right {
          grid-template-columns: 1fr;

          .stat-small {
            min-height: 90px;

            .small-info {
              margin-left: 50%;

              .small-label {
                font-size: 13px;
              }

              .small-value {

                &.join-count-value,
                &.cumulative-join-count-value,
                &.view-count-value,
                &.cumulative-view-count-value {
                  font-size: 22px;
                }
              }
            }
          }
        }
      }
    }

    .course-intro-content {
      .course-intro {
        .intro-content {
          font-size: 13px;
          line-height: 24px;
          padding: 12px;
        }
      }
    }
  }
}
</style>
